import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import TenantAPI from "../../api/TenantAPI";
import { handleUpdatedRecords } from "../../../utils/RecordUtils";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";

// For adding/removing an individual item(s) to specific record fields.
// Fields currently supported are: Email, Url, Phone
const useUpdateMultipleText = () => {
  const queryClient = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const updateMultipleText = useMutation({
    mutationFn: ({
      moduleAPIName,
      fieldAPIName,
      recordID,
      payload,
      subitemParent,
      subitemParentID,
    }: {
      moduleAPIName: string;
      fieldAPIName: string;
      recordID: string;
      payload?: any;
      subitemParent?: string;
      subitemParentID?: string;
      onSuccess?: () => void;
    }) => {
      return TenantAPI.updateMultipleText(
        moduleAPIName,
        fieldAPIName,
        recordID,
        payload,
        subitemParent,
        subitemParentID
      );
    },

    onSuccess: (data, { onSuccess }) => {
      const updatedRecord = data.data.data.data;

      handleUpdatedRecords(
        queryClient,
        updatedRecord._ModuleAPIName,
        updatedRecord,
        tenantID ?? ""
      );

      callFunctionIfExists(onSuccess);
    },
  });

  return {
    updateMultipleText: updateMultipleText.mutate,
    multipleTextUpdating: updateMultipleText.isPending,
    updateMultipleTextError: updateMultipleText.error,
  };
};

export default useUpdateMultipleText;
